export class Counter {
    public maxAllowedPersons: number;
    public closed: number;
    public currentPeopleAmount: number;
    public updatedPeopleAt: string;
    public timestamp: string;
    public blocked: number;
}
